module.exports = __webpack_public_path__ + "img/04.cb7bdb6b.png";